import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

// withCredentials so httpOnly session_token cookie (Google Auth) is sent.
export const api = axios.create({ baseURL: API_BASE, withCredentials: true });

api.interceptors.request.use((cfg) => {
  const token = localStorage.getItem("servisku_token");
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

export const formatRp = (n) => {
  const num = Number(n || 0);
  return "Rp " + num.toLocaleString("id-ID");
};

export const formatDate = (iso) => {
  if (!iso) return "-";
  try {
    return new Date(iso).toLocaleString("id-ID", {
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  } catch {
    return iso;
  }
};

export const COURIERS = ["JNE", "J&T Express", "SiCepat", "Anteraja", "Ninja Xpress", "Pos Indonesia", "Grab Express", "Gojek (GoSend)", "Lalamove", "Wahana", "Lainnya"];

export const statusMeta = {
  masuk: { label: "Masuk", cls: "bg-amber-50 text-amber-700 border-amber-200" },
  proses: { label: "Proses", cls: "bg-blue-50 text-blue-700 border-blue-200" },
  selesai: { label: "Selesai", cls: "bg-emerald-50 text-emerald-700 border-emerald-200" },
  selesai_ok: { label: "Selesai - OK", cls: "bg-emerald-50 text-emerald-700 border-emerald-200" },
  selesai_gagal: { label: "Selesai - Gagal", cls: "bg-red-50 text-red-700 border-red-200" },
  diambil: { label: "Diambil", cls: "bg-slate-100 text-slate-700 border-slate-300" },
};

// Compute display label & class combining outcome + pickup method
export const getStatusDisplay = (svc) => {
  if (!svc) return { label: "-", cls: "bg-slate-100 text-slate-700 border-slate-300" };
  const base = statusMeta[svc.status] || statusMeta.masuk;
  const isDone = svc.status === "selesai_ok" || svc.status === "selesai_gagal" || svc.status === "selesai";
  if (isDone && svc.pickup_method) {
    const outcome = svc.status === "selesai_gagal" ? "Gagal" : "OK";
    const pickup = svc.pickup_method === "delivery"
      ? (svc.courier ? `Dikirim (${svc.courier})` : "Dikirim")
      : "Ambil Sendiri";
    return { label: `Selesai ${outcome} · ${pickup}`, cls: base.cls };
  }
  return base;
};
